import { NextFunction, Request, Response } from 'express'
import { getDurationInMilliseconds, logger } from '../ultilities'
import chalk from 'chalk'

export const requestLogger = (req: Request, res: Response, next: NextFunction) => {
  const method = req.method
  const url = req.url
  const status = res.statusCode
  const start = process.hrtime()
  const durationInMilliseconds = getDurationInMilliseconds(start)
  const log = `${chalk.bold(method)}:${url} ${formatStatusCode(status)} ${chalk.yellow(
    `${durationInMilliseconds.toLocaleString()}ms`
  )}`

  if (url.startsWith('/__nextjs')) {
    logger.log(log)
  } else {
    logger.info(log)
  }
  next()
}

const formatStatusCode = (status: number) => {
  if (status < 200) return chalk.bold.blue(status)
  else if (status >= 200 && status < 300) return chalk.bold.green(status)
  else if (status >= 300 && status < 400) return chalk.bold.cyan(status)
  else if (status > 400) return chalk.bold.red(status)
}
